<script setup lang="ts">
/**
 * RiskSignalBadges — parses a JSON risk-signals string and renders one orange
 * chip per signal. Used inside FlagCallout and ApprovalCard.
 */
import type { RiskSignal } from '@/api/boardTypes';

const props = defineProps<{
  /** JSON-encoded RiskSignal[] string. If null/empty, renders nothing. */
  signalsJson: string | null | undefined;
}>();

function parseSignals(): RiskSignal[] {
  if (!props.signalsJson) return [];
  try {
    return JSON.parse(props.signalsJson) as RiskSignal[];
  } catch {
    return [];
  }
}
</script>

<template>
  <div v-if="parseSignals().length > 0" class="flex flex-wrap gap-1.5">
    <span
      v-for="sig in parseSignals()"
      :key="sig.signal"
      class="inline-flex items-center gap-1 px-2 h-[22px] text-caption font-semibold rounded-pill border bg-orange-100 text-orange-600 border-orange-100 whitespace-nowrap"
    >
      <span class="w-1.5 h-1.5 rounded-pill bg-orange-600" aria-hidden="true" />
      {{ sig.label }}
    </span>
  </div>
</template>
